/**
 * hero-carousel.js — Hero carousel with smooth crossfade, z-index management, and staggered text animation.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var carousel = document.querySelector('.hero-carousel, .hero');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.hero-slide');
    var dots   = carousel.querySelectorAll('.hero-dot');
    var prevBtn = carousel.querySelector('.hero-arrow--prev');
    var nextBtn = carousel.querySelector('.hero-arrow--next');
    if (slides.length === 0) return;

    var holdTime = parseInt(carousel.getAttribute('data-interval'), 10) * 1000 || 5000;
    var currentIndex = 0;
    var autoTimer = null;
    var isTransitioning = false;
    var TRANSITION_MS = 800;

    /* ---- helpers ---------------------------------------------------- */

    function goToSlide(index, skipAutoReset) {
      if (index === currentIndex || isTransitioning) return;
      isTransitioning = true;
      stopAuto();

      var outSlide = slides[currentIndex];
      var inSlide  = slides[index];

      // Bring outgoing slide to front so it fades over incoming
      outSlide.style.zIndex = '2';
      inSlide.style.zIndex  = '1';

      // Force reflow so z-index is applied before class change
      void inSlide.offsetWidth;

      // Start incoming slide visible underneath
      inSlide.classList.add('active');

      // Fade out the outgoing slide on top
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          outSlide.classList.remove('active');
        });
      });

      // Update dots
      dots[currentIndex] && dots[currentIndex].classList.remove('active');
      dots[index]        && dots[index].classList.add('active');

      currentIndex = index;

      // After transition completes, reset z-indices and restart hold timer
      setTimeout(function () {
        outSlide.style.zIndex = '';
        inSlide.style.zIndex  = '';
        isTransitioning = false;
        if (!skipAutoReset) startAuto();
      }, TRANSITION_MS + 100);
    }

    function nextSlide() {
      var next = (currentIndex + 1) % slides.length;
      goToSlide(next);
    }

    function prevSlide() {
      var prev = (currentIndex - 1 + slides.length) % slides.length;
      goToSlide(prev);
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(nextSlide, holdTime);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    /* ---- dot click -------------------------------------------------- */

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToSlide(i);
      });
    });

    /* ---- arrow click ------------------------------------------------ */

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide();
      });
    }

    /* ---- keyboard --------------------------------------------------- */

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prevSlide(); }
      if (e.key === 'ArrowRight') { nextSlide(); }
    });

    /* ---- swipe (touch) ---------------------------------------------- */

    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) nextSlide();
        else prevSlide();
      }
    }, { passive: true });

    /* ---- init ------------------------------------------------------- */

    slides.forEach(function (slide, i) {
      slide.classList.toggle('active', i === 0);
      slide.style.zIndex = i === 0 ? '1' : '';
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('active', i === 0);
    });

    currentIndex = 0;
    startAuto();

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);
  });
})();
